import { createSelector, Selector, State, StateContext } from '@ngxs/store';
import { Receiver } from '@ngxs-labs/emitter';
import { IdNamePair } from '../../@models/index';
import { Injectable, Injector } from '@angular/core';
import { ContactService } from '../../@services/contacts.service';
import { DropdownService } from '../../@services';
import { ENDPOINTS } from 'src/app/@config/endpoints';

@State<IdNamePair[]>({
  name: 'contactJobTitle',
  defaults: []
})
@Injectable()
export class ContactJobTitleState {

  private static service: DropdownService

  static hasAny() {
    return createSelector([ContactJobTitleState], (state: IdNamePair[]) => {
      return state.length > 0;
    });
  }

  static getNameById(id: number) {
    return createSelector([ContactJobTitleState], (state: IdNamePair[]) => {
      return state.find((item: IdNamePair) => item.id === id).name;
    });
  }

  constructor(injector: Injector) {
    ContactJobTitleState.service = injector.get(DropdownService);
  }

  @Receiver()
  static loadAll({ setState }: StateContext<ContactJobTitleState>) {
    this.service.getContactJobTitleDropdownData(ENDPOINTS.getContactJobTitleList()).subscribe(
      (data: IdNamePair[]) => {
        setState(data);
      }
    );
  }

}
